import './sign-in.scss';


// import modules this module depends on
import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';
import angularTranslate from 'angular-translate';
import gzEula from 'gazelle/src/components/user/eula/eula.module';
import rnSession from 'rhino/src/components/session/session.module';
import rnFeature from 'rhino/src/components/feature/feature.module';
import angularMoment from 'angular-moment';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';
import gzHpId from 'gazelle/src/components/hpid/hpid.module';
import detectAutoFill from './detectAutoFill.module';
import rnRegistry from 'rhino/src/core/registry/registry.module';
import rnStart from 'rhino/src/components/start/start.module';
import gazelleLocaleSelect from 'gazelle/src/components/locale-select/locale-select.module';

// import this modules components
import * as $stStations from './stations.service';
import * as signIn from './sign-in.controller';

// define the module in one place and export the module name
export default angular.module('register.components.signin', [
  gzEula,
  uiRouter,
  ngMaterial,
  angularMoment,
  angularTranslate,
  rnSession,
  rnFeature,
  rnStart,
  rnRegistry,
  gazelleAnalytics,
  gzHpId,
  gazelleLocaleSelect,
  'rhino.components.locale',
  'rhino.components.user',
  'rhino.core',
  'angulartics',
  detectAutoFill,
])
  .controller(signIn.name, signIn.default)
  .factory($stStations.name, $stStations.default)
  .name;




// WEBPACK FOOTER //
// ./components/sign-in/sign-in.module.js